'use client';

import React from 'react';
import { CheckCircle, X } from 'lucide-react';

interface SuccessModalProps {
  onClose: () => void;
}

export default function SuccessModal({ onClose }: SuccessModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 modal-backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="success-title"
    >
      <div
        className="relative bg-white rounded-2xl shadow-card-hover max-w-md w-full p-8 text-center scale-in"
        style={{ border: '2px solid #D4AF37' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-gray-100 transition-colors"
          aria-label="Close modal"
        >
          <X size={18} color="#6b6b6b" />
        </button>

        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-5 shadow-gold"
          style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #f0d060 100%)' }}
        >
          <CheckCircle size={40} color="#800000" strokeWidth={2} />
        </div>

        <div className="text-4xl mb-3 crown-icon" role="img" aria-label="Crown">👑</div>

        <h2 id="success-title" className="font-800 text-xl mb-3" style={{ color: '#800000' }}>
          Entry Submitted!
        </h2>

        <p className="text-sm leading-relaxed mb-6" style={{ color: '#3a3a3a' }}>
          Thank you for your entry. Please note you will get the pageant book in your email and be
          added in the finalists group.
        </p>

        <div
          className="rounded-xl p-4 mb-6 text-left"
          style={{ background: '#fff8e6', border: '1px solid #D4AF37' }}
        >
          <p className="text-xs font-600 mb-1" style={{ color: '#800000' }}>
            What happens next?
          </p>
          <ul className="text-xs space-y-1" style={{ color: '#5a5a5a' }}>
            <li>✦ Your entry will be reviewed within 3–5 business days</li>
            <li>✦ You will receive a confirmation email with the pageant book</li>
            <li>✦ Finalists will be announced on our social media pages</li>
          </ul>
        </div>

        <button
          onClick={onClose}
          className="w-full py-3 rounded-full font-700 text-sm tracking-widest btn-gold shadow-gold"
        >
          CLOSE
        </button>
      </div>
    </div>
  );
}